define('gigaset_csp/components/search/autocomplete',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem"
], function(
	$,
	Component,
	BEM
) {
	return Component.create({

		$init: function() {
			var $body = $(document.body);
			var self = this;

			this.blocks = BEM.block("csp-search-field");

			this.blocks.each(function() {
				var block = BEM.block(this);
				var inputs = block.getElements("input");
				var autocomplete = block.getElements("autocomplete");
				var autocompleteUlLiItems = null;
				var quicklinksTemplate = block.getElements('quicklinks-template').html();
				var quicklinks = null;

				function getQuicklinks() {
					if (null === quicklinks) {
						quicklinks = $(quicklinksTemplate).hide().insertAfter(autocomplete);
					}

					return quicklinks;
				}

				inputs.each(function() {
					var inputNode = this,
						input = $(inputNode),
						form = this.form,
						originalName = this.name,
						suffix = '',
						currentIndex = -1,
						currentElem = null;

					if (gigaset != 'undifined' && gigaset.store_code) {
						suffix = '&store=' + gigaset.store_code;
					}

					var url = input.data("autocomplete-url") + suffix;

					this.name = "q";
					var searchForm = new Varien.searchForm(form, this, input.attr("placeholder"));
					searchForm.initAutocomplete(url, autocomplete.get(0));
					this.name = originalName;

					input.on("focus keyup blur", function(e) {
						var value = input.val();
						var quicklinks = getQuicklinks();
						var hide = !!value.length;

						if (e.type === "blur") {
							hide = true;
							currentIndex = -1;
						}

						if ($.contains(quicklinks.get(0), e.relatedTarget)) {
							hide = false;
						}

						quicklinks[hide ? "hide" : "show"]();

						if (!hide) {
							$body.on("click", function onClick(e) {
								if (e.toElement && !$.contains(block.get(0), e.toElement)) {
									quicklinks.hide();
									currentIndex = -1;
									$body.off("click", onClick);
								}
							});
						}
					});

					var onKeyPress = function (event) {
						if (this.active) {
							return;
						}

						return searchForm.autocompleter.onKeyPress.apply(this, arguments);
					};

					Event.stopObserving(inputNode, 'keydown');
					Event.observe(inputNode, 'keydown', onKeyPress.bindAsEventListener(searchForm.autocompleter));

					input.on('keydown', function(e) {
						autocompleteUlLiItems = autocomplete.find('ul.b_search-autocomplete__list>li:not(.b_search-autocomplete__list-item--section)');
						// if(this.active)
						switch(event.keyCode) {
							case Event.KEY_RETURN:
								selectEntry(currentIndex);
								Event.stop(event);
								currentIndex = -1;
							case Event.KEY_ESC:
								autocomplete.hide();
								quicklinks.hide();
								// this.active = false;
								Event.stop(event);
								return;
							case Event.KEY_LEFT:
							case Event.KEY_RIGHT:
								return;
							case Event.KEY_UP:
								markPrevious();
								Event.stop(event);
								return;
							case Event.KEY_DOWN:
								markNext();
								Event.stop(event);
								return;
						}

						function markPrevious() {
							currentIndex --;
							if (currentIndex < -1) {
								currentIndex = autocompleteUlLiItems.length - 1;
							}
							updateStyling();
						}

						function markNext() {
							currentIndex ++;
							if (currentIndex > autocompleteUlLiItems.length - 1) {
								currentIndex = -1;
							}
							updateStyling();
						}

						function updateStyling() {
							var elem = $(autocompleteUlLiItems.get(currentIndex));
							autocompleteUlLiItems.removeClass('b_search-autocomplete__list-item--active');
							if (currentIndex === -1) {
								input.focus();
								self.scrollIntoViewIfNeeded(input);
							} else {
								elem.addClass('b_search-autocomplete__list-item--active');
								self.scrollIntoViewIfNeeded(elem);
							}
						}

						function selectEntry(index) {
							if (index > -1) {
								var elem = $(autocompleteUlLiItems.get(currentIndex)),
									link = elem.find('.b_search-autocomplete-item__link');
								if (link.is('a')) {
									location.href = link.prop('href');
								} else {
									link.trigger('click');
								}
							} else {
								form.submit();
							}
						}
					});
				});
			});
		},

		scrollIntoViewIfNeeded: function($target) {
			if ($target.offset()) {
				if ($target.offset().top < jQuery(window).scrollTop()){
					//scroll up
					$('html,body').animate({scrollTop: $target.offset().top});
				}
				else if ($target.offset().top + $target.outerHeight() >
					$(window).scrollTop() + (
						window.innerHeight || document.documentElement.clientHeight
					)) {
					//scroll down
					$('html,body').animate({scrollTop: $target.offset().top -
							(window.innerHeight || document.documentElement.clientHeight)
							+ $target.outerHeight()}
					);
				}
			}
		},


	});
});
